export default function Hero() {
  return (
    <section
      id="intro"
      data-aos="fade-up"
      className="section-frame min-h-screen flex items-center"
    >
      <div className="section-card grid w-full overflow-hidden rounded-[2rem] border md:grid-cols-[1.2fr_0.8fr]">
        <div className="px-6 py-24 sm:px-10 lg:px-14">
          <div className="section-label">
            <span className="h-2 w-2 rounded-full bg-sky-300" />
            Full Stack Developer
          </div>

          <h1 className="section-title mt-8 max-w-4xl text-slate-50">
            Hi, I'm Siva Sai Kumar. I'm a full-stack developer who enjoys building useful products, not just demo projects.
          </h1>

          <p className="mt-6 max-w-2xl text-xl font-medium leading-9 text-slate-300 md:text-2xl">
            I work mainly with React, Node.js, Express, and PostgreSQL, and I like building applications that solve day-to-day business problems in a simple and practical way.
          </p>

          <p className="section-copy mt-8 max-w-2xl text-base md:text-lg">
            I started my career in enterprise support and gradually moved into modern full-stack development. That experience taught me how to build software that is clean for users, stable in production, and useful for real teams. I am currently looking for full-stack opportunities in India where I can keep learning and contribute from day one.
          </p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row">
            <a href="#projects" className="button-primary">
              Explore Selected Work
            </a>
            <a href="/Siva_Resume.pdf" download className="button-secondary">
              Download Resume
            </a>
          </div>

          <div className="mt-10 grid gap-4 md:grid-cols-3">
            <div className="glass-chip rounded-3xl p-4">
              <p className="mono text-xs uppercase tracking-[0.3em] text-slate-500">Experience</p>
              <p className="mt-3 text-3xl font-bold text-slate-50">3+</p>
              <p className="mt-1 text-sm text-slate-400">Years building and supporting production systems</p>
            </div>
            <div className="glass-chip rounded-3xl p-4">
              <p className="mono text-xs uppercase tracking-[0.3em] text-slate-500">Core Stack</p>
              <p className="mt-3 text-2xl font-bold text-slate-50">React / Node</p>
              <p className="mt-1 text-sm text-slate-400">UI engineering, APIs, automation, PostgreSQL</p>
            </div>
            <div className="glass-chip rounded-3xl p-4">
              <p className="mono text-xs uppercase tracking-[0.3em] text-slate-500">Focus</p>
              <p className="mt-3 text-2xl font-bold text-slate-50">Useful Systems</p>
              <p className="mt-1 text-sm text-slate-400">Apps that reduce manual work and improve decisions</p>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800/70 bg-slate-950/40 px-6 py-10 sm:px-10 md:border-l md:border-t-0 lg:px-12">
          <div className="glass-chip rounded-[1.75rem] p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="mono text-xs uppercase tracking-[0.3em] text-slate-500">Live Signal</p>
                <h2 className="mt-2 text-2xl font-semibold text-slate-50">What I optimize for</h2>
              </div>
              <span className="rounded-full border border-emerald-400/30 bg-emerald-400/10 px-3 py-1 text-xs font-medium text-emerald-300">
                Available
              </span>
            </div>

            <div className="signal-line mt-8 space-y-8 pl-6">
              <div>
                <p className="mono text-xs uppercase tracking-[0.3em] text-sky-300">01</p>
                <h3 className="mt-2 text-lg font-semibold text-slate-100">Business-focused builds</h3>
                <p className="mt-2 text-sm leading-7 text-slate-400">I like working on products that solve actual workflow problems for employees, teams, and internal operations.</p>
              </div>
              <div>
                <p className="mono text-xs uppercase tracking-[0.3em] text-sky-300">02</p>
                <h3 className="mt-2 text-lg font-semibold text-slate-100">Clean full-stack delivery</h3>
                <p className="mt-2 text-sm leading-7 text-slate-400">From frontend UI to backend APIs and database design, I enjoy owning the complete flow of an application.</p>
              </div>
              <div>
                <p className="mono text-xs uppercase tracking-[0.3em] text-sky-300">03</p>
                <h3 className="mt-2 text-lg font-semibold text-slate-100">Strong learner mindset</h3>
                <p className="mt-2 text-sm leading-7 text-slate-400">I am comfortable adapting quickly, picking up new tools, and improving both code quality and product thinking over time.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
